import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '#lib/helpers/class';
import { hasElements } from '#lib/utils/array';
import { ResponsiveNav } from './responsive-nav.jsx';

export default function NavBar(props) {
    const { navigation } = props;
    const entries = Object.entries(navigation).filter(([, items]) => hasElements(items));

    return (
        <div className="order-last md:order-none flex items-center px-2 gap-4 h-full text-sm">
            {entries.map(([key, items], index) => (
                <React.Fragment key={key}>
                    {index !== 0 && <span className="h-4 w-px translate-y-0.5 bg-neutral-200" aria-hidden />}
                    <ResponsiveNav itemsCount={items.length}>
                        {items.map(({ to, end, Icon, name }) => (
                            <NavLink
                                className={({ isActive }) =>
                                    cn(
                                        isActive
                                            ? 'bg-primary-600  !text-white'
                                            : 'bg-transparent text-neutral-600 hover:text-primary-600',
                                        '-mx-2 -my-1.5 inline-flex whitespace-nowrap rounded-lg px-3 py-1.5 transition-colors'
                                    )
                                }
                                key={to}
                                to={to}
                                end={end}
                                state={{ from: location.pathname }}
                            >
                                {Icon && <Icon className="icon-sm mr-2" />}
                                {name}
                            </NavLink>
                        ))}
                    </ResponsiveNav>
                </React.Fragment>
            ))}
        </div>
    );
}
